import { render } from "./OrgCouncilersList.vue?vue&type=template&id=229dfef3&scoped=true"
import script from "./OrgCouncilersList.vue?vue&type=script&lang=js"
export * from "./OrgCouncilersList.vue?vue&type=script&lang=js"

import "./OrgCouncilersList.vue?vue&type=style&index=0&id=229dfef3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229dfef3"]])

export default __exports__